import type { RootState } from "src/store";

export const selectBackground = (state: RootState) => {
  return state.background;
};
